/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EntityParameterDto } from '../models/entity-parameter-dto';
import { entityParameterGetAsDto } from '../fn/entity-parameter/entity-parameter-get-as-dto';
import { EntityParameterGetAsDto$Params } from '../fn/entity-parameter/entity-parameter-get-as-dto';

@Injectable({ providedIn: 'root' })
export class EntityParameterService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `entityParameterGetAsDto()` */
  static readonly EntityParameterGetAsDtoPath = '/v1/EntityParameter/GetAsDTO';

  /**
   * Search entity parameter as DTO depending on application type (AllowAnonymous) ,   Restricted to [HOSPITAL|KIOSK_HOME|INSURER].
   *
   * <br />Anonymous access
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entityParameterGetAsDto()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityParameterGetAsDto$Response(params?: EntityParameterGetAsDto$Params, context?: HttpContext): Observable<StrictHttpResponse<EntityParameterDto>> {
    return entityParameterGetAsDto(this.http, this.rootUrl, params, context);
  }

  /**
   * Search entity parameter as DTO depending on application type (AllowAnonymous) ,   Restricted to [HOSPITAL|KIOSK_HOME|INSURER].
   *
   * <br />Anonymous access
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `entityParameterGetAsDto$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityParameterGetAsDto(params?: EntityParameterGetAsDto$Params, context?: HttpContext): Observable<EntityParameterDto> {
    return this.entityParameterGetAsDto$Response(params, context).pipe(
      map((r: StrictHttpResponse<EntityParameterDto>): EntityParameterDto => r.body)
    );
  }

}
